module.exports = __webpack_public_path__ + "media/images/business_man-56c7da0681c35e106e21cc92c9a5f2c0.svg";